import { Select } from "antd";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import * as React from "react";
import { userInfoStore } from "Stores";

// const twoFactorNameMap: { [key in API_USERLOGINSETTING_LOGINTYPE]?: string } = {
//   STANDARD: "Standard",
//   TOTP: "Google-Authenticator",
//   SMS: "SMS TAN",
//   EMAIL: "Mail TAN",
// };

export const User2FASelect = ({ unifiedAccount }: { unifiedAccount: boolean }) => {
  const [availableMethods, setAvailableMethods] = React.useState([]);
  const [displayNames, setDisplayNames] = React.useState({});
  const [currentMethod, setCurrentMethod] = React.useState<API_USERLOGINSETTING_LOGINTYPE>(null);

  const fetch = async () => {
    let url: string;
    if (unifiedAccount) {
      url = API_URL.PAVE_USERS.getLoginTypePAVEUser(userInfoStore.id);
    } else {
      url = API_URL.USERS.getLoginType(userInfoStore.id);
    }
    const response = await API.getData<API_UserLoginSetting>(url);
    setAvailableMethods(response.availableTypes.filter((type) => type !== "SMS"));
    setCurrentMethod(response.loginType);
    setDisplayNames(response.displayNames);
  };

  const handleChangeMethod = async (value) => {
    setCurrentMethod(value);
    let url: string;
    if (unifiedAccount) {
      url = API_URL.PAVE_USERS.updateLoginTypePaveUser(userInfoStore.id);
    } else {
      url = API_URL.USERS.updateLoginType(userInfoStore.id);
    }
    await API.editData(url, null, { type: value });
  };

  React.useEffect(() => {
    fetch();
  }, []);

  return (
    <Select<API_USERLOGINSETTING_LOGINTYPE>
      onChange={handleChangeMethod}
      value={currentMethod}
      options={availableMethods.map((item) => ({ label: displayNames[item], value: item }))}
    />
  );
};
